import { Component, OnInit } from '@angular/core';
import { APPCONFIG } from '../../config';

@Component({
    selector: 'my-app-footer',
    styles: [],
    template: require('./footer.component.html')
})

export class AppFooterComponent implements OnInit {
    public AppConfig: any;

    ngOnInit() {
        this.AppConfig = APPCONFIG;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/footer/footer.component.ts